import { call, put, takeEvery } from "redux-saga/effects";
import Constants from "../../Action/Constants";
import { ErrorHandlerSequence } from "../Sequences/ErrorHandlerSequence";
import Http from "../../Http/Http";
import { ActionInterface } from "../../Interface/ActionInterface";
import ChargeFactory from "../../Entity/Factories/ChargeFactory";
import { ChargeInterface } from "../../Entity/Entities/Charge/ChargeInterface";
import Translator from "../../Translation/Translator";

export default function* paymentSettle(action: ActionInterface): any {
  try {
    yield put({
      type: Constants.GLOBAL_CHARGE_SETTLE_CLEAR
    });

    yield put({
      type: Constants.GLOBAL_PAYMENT_SETTLE_REQUEST
    })

    let payload: any = {};

    if (!!action.payload?.paymentId) {
      payload.paymentId =  action.payload?.paymentId;
    }

    if (!!action.payload?.newPayment) {
      payload.newPayment = {...action.payload?.newPayment};
    }

    const res = yield call(Http.post, `payment/${action.payload?.id}/settle`, {
      ...payload
    });

    const charge: ChargeInterface = ChargeFactory.create(res.data.data);

    yield put({
      type: Constants.GLOBAL_PAYMENT_SETTLE_SUCCESS
    })

    yield put({
      type: Constants.GLOBAL_PAYMENTS_LIST_OUTDATE_REQUESTS
    })

    yield put({
      type: Constants.GLOBAL_CHARGES_LIST_OUTDATE_REQUESTS
    })

    yield put({
      type: Constants.SNACKBAR_ADD_MESSAGE,
      payload: {
        message: Translator.trans("snackbar-message-payment-settled-successfully"),
        type: "success"
      }
    });

    if (action.hasOwnProperty("onSuccess") === true) {
      action.onSuccess.call(this, charge);
    }

  } catch (err) {
    yield ErrorHandlerSequence(err, action);

    yield put({
      type: Constants.GLOBAL_PAYMENT_SETTLE_FAILURE,
      payload: {
        err: err
      }
    });
  }
}

export function* watchPaymentSettle() {
  yield takeEvery(Constants.GLOBAL_PAYMENT_SETTLE_START, paymentSettle);
}
